import graphql from "babel-plugin-relay/macro";
import { MotiView } from "moti";
import { useFragment } from "react-relay";

import { MemberModalSelectedMemberMemberDisplay } from "./MemberModalSelectedMemberMemberDisplay";
import { MemberModalSelectedMember_Member$key } from "./__generated__/MemberModalSelectedMember_Member.graphql";

export const MemberModalSelectedMember = ({
  memberRef,
  onClose,
}: {
  memberRef: MemberModalSelectedMember_Member$key | null;
  onClose: () => void;
}) => {
  const member = useFragment(
    MemberModalSelectedMemberfragmentString,
    memberRef
  );
  const fullName = `${member?.firstName} ${member?.lastName}`;

  const currentAnimationValue = member
    ? { opacity: 1, right: 0 }
    : { opacity: 0, right: -15 };

  return (
    <MotiView
      style={{
        position: "absolute",
        top: -242,
        bottom: 0,
        width: "100%",
        pointerEvents: member ? "auto" : "none",
      }}
      transition={{
        opacity: {
          type: "timing",
          duration: 200,
        },
        right: { type: "timing", duration: 200 },
      }}
      from={{ opacity: 0, right: -15 }}
      animate={currentAnimationValue}
      exit={{ opacity: 0, right: -15 }}
    >
      {member ? (
        <MemberModalSelectedMemberMemberDisplay
          fullName={fullName}
          firstName={member?.firstName ?? null}
          lastName={member?.lastName ?? null}
          onClose={onClose}
          phone={member.phoneNumber?.nationalNumber}
          email={member.email}
          profileImageId={member.profileImage?.publicId}
        />
      ) : (
        /*
         * This second portion exists only so that when we are animating closed, we still
         * display a sort of skeleton of content, rather than just blank white.
         */
        <MemberModalSelectedMemberMemberDisplay
          firstName={"Member"}
          lastName={"Name"}
          fullName="Member Name"
          onClose={onClose}
        />
      )}
    </MotiView>
  );
};

export const MemberModalSelectedMemberfragmentString = graphql`
  fragment MemberModalSelectedMember_Member on Member {
    id
    firstName
    lastName
    profileImage {
      # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
      publicId: renderingKey
    }
    email
    phoneNumber {
      nationalNumber
    }
  }
`;
